export default "__VITE_ASSET__bda44b25__"